import type { IDurationOptions, IEventOptions, IFailureOptions } from './types';

export abstract class LoggerAdapter {
  public abstract logEvent(metric: string, options?: IEventOptions): void;
  /** @deprecated
   * use logEvent(metric: string, options?: IEventOptions): void; instead
   * */
  public abstract logEvent(
    logger_name: string,
    metric: string,
    timestamp: number,
    count: number,
    key: string,
    instant: boolean,
    bandwidth?: number
  ): void;

  public abstract logDuration(metric: string, options: IDurationOptions): void;
  /** @deprecated
   * use logDuration(metric: string, options: IDurationOptions): void; instead
   * */
  public abstract logDuration(
    logger_name: string,
    metric: string,
    timestamp: number,
    duration: number,
    key: string,
    instant: boolean,
    bandwidth?: number
  ): void;

  public abstract logFailure(type: string, options?: IFailureOptions): void;
  /** @deprecated
   * use logFailure(type: string, options?: IFailureOptions): void; instead
   * */
  public abstract logFailure(
    logger_name: string,
    type?: string,
    place?: string,
    timestamp?: number,
    count?: number,
    key?: string,
    instant?: boolean
  ): void;

  public abstract logSearchQuery(query: string, vendor: string, result: string): void;

  public abstract logFailedTranslation(translationKey: string, language?: string): void;

  public abstract logException(exception: Error): void;
}
